export const DASHBOARD_TO_ADD_TO_PARAM = 'dashboardToAddTo';
export const DASHBOARD_LAYOUT_ROW_ID_PARAM = 'dashboardLayoutRowID';
export const DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION =
  'dashboardLayoutCellInsertDir';
